<header role="banner" class="form-input__header">
  <p *ngIf="question.title" class="form-input__header__title" [innerHTML]="title"></p>
  <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
</header>

<mat-form-field class="form-input__field form-input__field--text" appearance="outline">
  <mat-label>
    <ng-container *ngIf="!!label; else noLabel">{{ label }}</ng-container>
    <ng-template #noLabel>
      <ng-container [ngSwitch]="locationType">
        <ng-container *ngSwitchCase="'city'">Ville</ng-container>
        <ng-container *ngSwitchCase="'country'">Pays</ng-container>
        <ng-container *ngSwitchCase="'address'">Adresse</ng-container>
      </ng-container>
    </ng-template>
  </mat-label>
  <input
    [id]="elm_id"
    type="text"
    class="textfield"
    (cdkAutofill)="updateAutofilled($event)"
    [matAutocomplete]="autocompleteRef"
    (blur)="focused = autocompleteRef.isOpen"
    (focus)="focused = true"
    autocomplete="no"
    [formControl]="control"
    [placeholder]="placeholder"
    [required]="required"
    matInput
    #textfieldRef
  />

  <mat-autocomplete
    autoActiveFirstOption
    [displayWith]="displayFn"
    (optionSelected)="selectOption($event.option.value)"
    (closed)="doClosed()"
    #autocompleteRef="matAutocomplete"
  >
    <ng-container *ngFor="let city of cities$ | async; trackBy: trackByCityPlaceId">
      <mat-option *ngIf="city.cityPlaceId !== value?.cityPlaceId" [value]="city">{{ city.short }}</mat-option>
    </ng-container>
  </mat-autocomplete>

  <mat-error *ngIf="((parentFormSubmitted$ | async) === true || control.touched) && !!control?.errors?.required">
    <ng-container *ngIf="!!errorMsg">{{ errorMsg }}</ng-container>
    <ng-container *ngIf="!errorMsg" [ngSwitch]="locationType">
      <ng-container *ngSwitchCase="'city'">Veuillez saisir une ville</ng-container>
      <ng-container *ngSwitchCase="'country'">Veuillez saisir un pays</ng-container>
      <ng-container *ngSwitchCase="'address'">Veuillez saisir une adresse</ng-container>
      <ng-container *ngSwitchDefault>Veuillez saisir une valeur</ng-container>
    </ng-container>
  </mat-error>

  <mat-error *ngIf="((parentFormSubmitted$ | async) === true || control.touched) && !!control?.errors?.cityRequired">
    <ng-container [ngSwitch]="locationType">
      <ng-container *ngSwitchCase="'city'">La ville saisie est incorrecte</ng-container>
      <ng-container *ngSwitchCase="'country'">Le pays saisi est incorrecte</ng-container>
      <ng-container *ngSwitchCase="'address'">L&apos;adresse saisie est incorrecte</ng-container>
      <ng-container *ngSwitchDefault>La valeur saisie est incorrecte</ng-container>
    </ng-container>
  </mat-error>
</mat-form-field>

<footer class="form-input__actions">
  <button
    class="btn"
    type="button"
    (click)="next(control)"
    [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
  >
    Valider
  </button>
  <button
    *ngIf="!required"
    class="btn-clean"
    type="button"
    (click)="skipQuestion.emit(control)"
    [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
  >
    Passer
  </button>
</footer>
